// Code review - In Progress
// Documentation - In Progress

import React, { useState } from "react";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import { mappingroomtype } from "../components/HeaderAttribute";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";

import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import toast from "react-hot-toast";
import { useEffect } from "react";
import Loader from "../ReusableComponents/Loader";
import MappingRoomTypeWithSpacesPopp from "../popup-containers/MappingRoomTypeWithSpacesPopp";
import { filter } from "jszip";
import MapViewPopp from "../popup-containers/MapViewPopp";
import PopUpButtons from "../components/PopUpButtons";



const MappingRoomTypeWithSpaces = () => {

    // UI use state management
    const [isLoading, setIsLoading] = useState(false);
    const [popUpOpen, setpopUpOpen] = useState(false);
    const [popUpOpen1, setpopUpOpen1] = useState(false);
    const [roomType, setRoomType] = useState('');
    const [roomTypeName, setRoomTypeName] = useState('');
    const [spaceDatas, setSpaceDatas] = useState([]);
    const [mapRoomTypeAndSpacDatas, setMapRoomTypeAndSpacDatas] = useState([]);
    const mstClientId = sessionStorage.getItem("MstClientId");

    // Grid data
    const [bindRoomTypeDatas, setBindRoomTypeDatas] = useState([]);
    const [bindSpaceDatas, setBindSpaceDatas] = useState([]);
    const [bindMapRoomTypeAndSpaceDatas, setBindMapRoomTypeAndSpaceDatas] = useState([]);


    useEffect(() => {

        getRoomTypeTableDatas();
        getSpaceTableDatas();
        getMapRoomTypeAndSpaceDatas();
    }, []);

    useEffect(() => {
        if (!popUpOpen) {
            cancel()
        }

    }, [popUpOpen]);

    // Getting Room Type values
    const getRoomTypeTableDatas = async () => {
        const data = {
            mstClientId: mstClientId,
        };
        setIsLoading(true); 
        const response = await BindPostAPI(data, "RoomTypeAPI/BindRoomType");
        setBindRoomTypeDatas(response.data.Table);
        setIsLoading(false); 
    };


    // Getting Space values
    const getSpaceTableDatas = async () => {
        const data = {
            mstClientId: mstClientId,
        };
        setIsLoading(true); 
        const response = await BindPostAPI(data, "SpaceAPI/BindSpace");
        setBindSpaceDatas(response.data.Table);
        setIsLoading(false); 
    };

    // Getting Space values
    const getMapRoomTypeAndSpaceDatas = async () => {
         
        const data = {
            mstClientId: mstClientId,
        };
        setIsLoading(true); 
        const response = await BindPostAPI(data, "MappingAPI/BindMapRoomTypeAndSpace");
        setBindMapRoomTypeAndSpaceDatas(response.data.Table);
        setIsLoading(false); 
    };
    const handlePopup = (rowIndex, flag) => {

        setpopUpOpen(true)


        var RoomtypeId = (bindRoomTypeDatas[rowIndex].MstRoomTypeId);
        console.log(RoomtypeId);

        setRoomType(RoomtypeId)
        setSpaceDatas(bindSpaceDatas)
        const filteredMapData = bindMapRoomTypeAndSpaceDatas.filter(
            item => item.MstRoomTypeId === RoomtypeId
        );

        setMapRoomTypeAndSpacDatas(filteredMapData)
    };

    const handlePopup1 = (rowIndex, flag) => {


        var RoomtypeId = (bindRoomTypeDatas[rowIndex].MstRoomTypeId);
        var Roomtype = (bindRoomTypeDatas[rowIndex].RoomType);
        console.log(RoomtypeId);

        setRoomType(RoomtypeId)

        setRoomTypeName(Roomtype)

        const filteredMapData = bindMapRoomTypeAndSpaceDatas.filter(
            item => item.MstRoomTypeId === RoomtypeId
        );
        if (filteredMapData.length != 0) {
            setpopUpOpen1(true)
            setMapRoomTypeAndSpacDatas(filteredMapData)

        } else {

            toast.error(
                `No data available. 👎`,
                {
                    duration: 3000,
                    position: "top-center",
                }
            );
        }

    };
    const cancel = () => {
        setpopUpOpen1(false)
        setRoomType('')
        setRoomTypeName('')
        setMapRoomTypeAndSpacDatas([])
        getRoomTypeTableDatas();
        getSpaceTableDatas();
        getMapRoomTypeAndSpaceDatas();
    };


    return (
        <MainLayout pageName={"2"}>
            <Loader
                isVisible={isLoading}
                size="h-20 w-20"
                color="border-t-black"
                blur={true}
            />
            <GridPage
                title="Map Room Type and Space"
                header={mappingroomtype}
                records={bindRoomTypeDatas}
                blockView={true}
                addView={true}
                onMap={handlePopup}
                onMapView={handlePopup1}
            />


            <MainPopup
                popUpOpen={popUpOpen}
                setpopUpOpen={setpopUpOpen}
                Open={handlePopup}
            >
                <div>
                    <PopUpScreenTitle
                        title="Map Room Type and Space"
                        setpopUpOpen={setpopUpOpen}
                        hederDetails={true}
                    />

                    <MappingRoomTypeWithSpacesPopp
                        data1={roomType}
                        spaceData={spaceDatas}
                        isOpen={setpopUpOpen}
                        data2={mapRoomTypeAndSpacDatas} />
                </div>


            </MainPopup>
            <MainPopup
                popUpOpen={popUpOpen1}
                setpopUpOpen={setpopUpOpen1}
                Open={handlePopup1}
            >
                <div>
                    <PopUpScreenTitle
                        title="Map Room Type and Space"
                        setpopUpOpen={setpopUpOpen1}
                        viewDetails={true}
                    />

                    <MapViewPopp
                        data={0}
                        data1={roomTypeName}
                        data2={mapRoomTypeAndSpacDatas} />
                    <PopUpButtons
                        viewDetails={true}
                        cancel={cancel}
                    />
                </div>

            </MainPopup>
        </MainLayout>
    );
};
export default MappingRoomTypeWithSpaces;
